import { createAction } from '@reduxjs/toolkit';
import { Case } from './action-types';
import type { CaseDetailChangedEntry } from '../core/case-accelerator';

/** @deprecated Manual apply path removed; Case Accelerator auto-applies Phase 2 on drift. */
export const caseDetailReconciliationPending = createAction<CMxAPI.Case>(
  Case.CASE_DETAIL_RECONCILIATION_PENDING
);

/**
 * Phase 2 differed from the cache HIT and was auto-applied.
 * `payload` is the meaningful left/right diff retained for a stacked comparison-modal PR.
 */
export const caseDetailReconciliationApplied = createAction<
  CaseDetailChangedEntry[]
>(Case.CASE_DETAIL_RECONCILIATION_APPLIED);

export const caseDetailFreshnessWarning = createAction<void>(
  Case.CASE_DETAIL_FRESHNESS_WARNING
);

/** @deprecated Manual apply path removed; kept for prop compatibility during transition. */
export const applyCaseDetailReconciliation = createAction<void>(
  Case.CASE_DETAIL_RECONCILIATION_APPLY
);

export const dismissCaseDetailReconciliation = createAction<void>(
  Case.CASE_DETAIL_RECONCILIATION_DISMISS
);

export const dismissCaseDetailFreshnessWarning = createAction<void>(
  Case.CASE_DETAIL_FRESHNESS_WARNING_DISMISS
);
